module.exports = __webpack_public_path__ + "static/img/hy_02.7cda35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy_02.png
// module id = fTlx
// module chunks = 0